import { ConfirmationDialog } from "../../common/ConfirmationDialog";
import { IMessage } from "@home-health-notify/domain";
import { useTranslation } from "hhn-commons";

interface DeleteConfirmationDialogProps {
  messageToDelete: IMessage | null;
  onClose: () => void;
}

export const DeleteConfirmationDialog = ({
  messageToDelete,
  onClose,
}: DeleteConfirmationDialogProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "groupChatInfo" });

  const onDeleteMessage = () => {
    messageToDelete?.deleteMessage();
    onClose();
  };

  return (
    <ConfirmationDialog
      isOpen={messageToDelete !== null}
      onClose={onClose}
      confirmationTitle={tNs("deleteMessage")}
      confirmationMessage={tNs("confirmDeleteMessage")}
      confirmationButtonText={tNs("delete")}
      onConfirmationAction={onDeleteMessage}
    />
  );
};
